import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To keep the JavaScript ecosystem healthy, reliable, and secure, every time you make significant updates to an npm package you own, we recommend publishing a new version of the package with an updated version number in the `}<a parentName="p" {...{
        "href": "creating-a-package-json-file"
      }}><inlineCode parentName="a">{`package.json`}</inlineCode>{` file`}</a>{` that follows the `}<a parentName="p" {...{
        "href": "http://semver.org/"
      }}>{`semantic versioning spec`}</a>{`. Following the semantic versioning spec helps other developers who depend on your code understand the extent of changes in a given version, and adjust their own code if necessary.`}</p>
    <div className="note">
      <span className="bold">Note:</span> If you introduce a change that breaks a package dependency, we strongly recommend incrementing the version <span className="bold">major number</span>; see below for details.
    </div>
    <h2>{`Incrementing semantic versions in published packages`}</h2>
    <p>{`To help developers who rely on your code, we recommend starting your package version at `}<inlineCode parentName="p">{`1.0.0`}</inlineCode>{` and incrementing as follows:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Code status`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Stage`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Rule`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Example version`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`First release`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Start with 1.0.0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.0.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Backward compatible bug fixes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Patch release`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Increment the third digit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.0.1`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Backward compatible new features`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Minor release`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Increment the middle digit and reset last digit to zero`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.1.0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Changes that break backward compatibility`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Major release`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Increment the first digit and reset middle and last digits to zero`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2.0.0`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Using semantic versioning to specify update types your package can accept`}</h2>
    <p>{`You can specify which update types your package can accept from dependencies in your package's `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
    <p>{`For example, to specify acceptable version ranges up to 1.0.4, use the following syntax:`}</p>
    <ul>
      <li parentName="ul">{`Patch releases: `}<inlineCode parentName="li">{`1.0`}</inlineCode>{` or `}<inlineCode parentName="li">{`1.0.x`}</inlineCode>{` or `}<inlineCode parentName="li">{`~1.0.4`}</inlineCode></li>
      <li parentName="ul">{`Minor releases: `}<inlineCode parentName="li">{`1`}</inlineCode>{` or `}<inlineCode parentName="li">{`1.x`}</inlineCode>{` or `}<inlineCode parentName="li">{`^1.0.4`}</inlineCode></li>
      <li parentName="ul">{`Major releases: `}<inlineCode parentName="li">{`*`}</inlineCode>{` or `}<inlineCode parentName="li">{`x`}</inlineCode></li>
    </ul>
    <p>{`For more information on semantic versioning syntax, see the `}<a parentName="p" {...{
        "href": "https://semver.npmjs.com/"
      }}>{`npm semver calculator`}</a>{`.`}</p>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`
"dependencies": {
  "my_dep": "^1.0.0",
  "another_dep": "~2.2.0"
},
`}</code></pre>
    <h2>{`Resources`}</h2>
    <iframe src="https://www.youtube.com/embed/kK4Meix58R4" frameBorder="0" allowFullScreen></iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      